var _a, _b;
import { NotificationEnumns } from "../types/enumerations";
export var defaultGraphData = {
    production: {
        incidents: {},
        maintenances: {}
    },
    stage: {
        incidents: {},
        maintenances: {}
    },
    ongoingProduction: {
        incidents: {},
        maintenances: {}
    },
    ongoingStage: {
        incidents: {},
        maintenances: {}
    },
};
export var DATE_FORMAT_SL = "DD/MM/YYYY";
export var DATE_FORMAT_MNAME = "MMMM DD, YYYY";
export var PAST_NOTF_PILL_COLOR = "#CEE4C4";
export var FUT_NOTF_PILL_COLOR = "#BFBFBF";
export var IN_GRAPH_COLOR = "#FF3A67";
export var MN_GRAPH_COLOR = "#0074BD";
export var siteAlertStatusMap = (_a = {},
    _a[NotificationEnumns.SITE_ALERT_STATUS.ACTIVE] = [1, 5],
    _a[NotificationEnumns.SITE_ALERT_STATUS.RESOLVED] = [4],
    _a[NotificationEnumns.SITE_ALERT_STATUS.UPCOMING] = [3],
    _a);
export var ongoingNotificationMap = (_b = {},
    _b[NotificationEnumns.NOTIFICATION_TYPE.MAINTENANCE] = [2, 5],
    _b[NotificationEnumns.NOTIFICATION_TYPE.INCIDENTS] = [1, 2],
    _b);
//# sourceMappingURL=status.js.map